import { IconDefinition } from "./types";

const minus: IconDefinition = {
  iconName: "minus",
  width: 16,
  height: 16,
  svgPathData: "M15.071 8H.93",
  iconType: "stroke",
};

export { minus };
